var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.useSplitScreen())?[_c('router-view')]:_vm._e(),(_vm.useSplitScreen())?[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('ProjectPreferencesMenu')],1),_c('div',{staticClass:"col-md-9"},[_c('router-view')],1)])]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }